import { useFocusable } from "@react-aria/focus";
import { useRef } from "react";

const CustomTooltipTrigger = ({ children, className }: React.PropsWithChildren<{ className?: string }>) => {
  const ref = useRef<HTMLDivElement>(null);
  const { focusableProps } = useFocusable({}, ref);

  return (
    // oxlint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <div
      ref={ref}
      className={className}
      {...focusableProps}
      tabIndex={0}
    >
      {children}
    </div>
  );
};

export default CustomTooltipTrigger;
